module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"buttons\"><%\nfor(let button of Object.values((formMapping || {}).buttons || {})){\nbutton = button || {}\nconst type = button.type || 'default'\nif(\n(!button.privilegeCode || helpers.hasAccessTo(button.privilegeCode))\n&&\n(!button.roleOption || helpers.hasRoleOption(button.roleOption))\n){\n%><%- include('buttons/' + type, { formMapping: button }); %><%\n}\n}\n%></div>"
  , __filename = "components/templates/core/form/elements/buttons.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"buttons\">")
    ; 
for(let button of Object.values((formMapping || {}).buttons || {})){
button = button || {}
const type = button.type || 'default'
if(
(!button.privilegeCode || helpers.hasAccessTo(button.privilegeCode))
&&
(!button.roleOption || helpers.hasRoleOption(button.roleOption))
){

    ; __line = 10
    ; __append( include('buttons/' + type, { formMapping: button }) )
    ; 
}
}

    ; __line = 13
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/form/elements/buttons.ejs

}